<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{ aLang.c_list }} người dùng
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form ref="myForm" label-position="top" @submit.native.prevent
                :model="mData.tableRules.dataSearch.value" :rules="mData.tableRules.dataSearch.valid">
                <b-row>
                  <b-col md="3">
                    <el-form-item label="Tên tài khoản" prop="">
                      <el-input v-model="mData.tableRules.dataSearch.value.account" clearable
                        placeholder="Nhập từ khóa (nhấn enter để tìm kiếm)">
                      </el-input>
                    </el-form-item>
                  </b-col>
                  <!-- <b-col md="3">
                    <el-form-item label="Tên người dùng" prop="">
                      <el-select
                        v-model="mData.tableRules.dataSearch.value.id"
                        :placeholder="aLang.c_select"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listTenNguoiDung"
                          :key="item.id"
                          :label="item.ho_ten"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col> -->
                  <b-col md="3">
                    <el-form-item label="Quyền" prop="">
                      <el-select v-model="mData.tableRules.dataSearch.value.roles" :placeholder="aLang.c_select"
                        clearable filterable>
                        <el-option v-for="item in mData.dataDefault.accountRolesSearch" :key="item.code"
                          :label="item.text" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Trạng thái khoá" prop="">
                      <el-select v-model="mData.tableRules.dataSearch.value.disabled" placeholder="Trạng thái"
                        :default-first-option="true" clearable filterable>
                        <el-option v-for="item in mData.dataDefault.listLockStatus" :key="item.value"
                          :label="item.label" :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button type="info" native-type="submit" v-ladda plain @click="fn_tableSearch()">{{
                    aLang.c_search
                  }}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col :class="'col-md-8'">
          </b-col>
          <b-col :class="'col-md-4'">
            <div class="text-right mb-2">
              <el-button @click="fn_tableShowFormSearch()" type="info" plain>{{ aLang.c_showHideSearch }}</el-button>
              <el-button @click="fn_handle('create')" type="info" plain>{{ aLang.c_create }}</el-button>
            </div>
          </b-col>
        </b-row>
        <el-table :data="mData.tableRules.data" border @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange" max-height="440" style="width: 100%"
          :default-sort="{ prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1] }">
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>

          <el-table-column prop="disabled" :sortable="mData.tableRules.allowSorting" label="Khóa" width="80"
            align="center">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.disabled"
                @change="fn_changeDisable(scope.row.id, scope.row.disabled)"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="account" label="Tên tài khoản" :sortable="mData.tableRules.allowSorting">
            <template slot-scope="scope">
              <el-link class="cell-child" target="_blank" @click="fn_handle('detail', scope.$index, scope.row)"
                :underline="false">{{ scope.row.account }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="Tên người dùng"
            :sortable="mData.tableRules.allowSorting"></el-table-column>
          <el-table-column prop="roles" label="Quyền" :sortable="mData.tableRules.allowSorting"
            :formatter="fn_formatterRoles">
            <!-- <template slot-scope="scope">
              <div class="text-center">
                {{scope.row.roles}}
              </div>
            </template> -->
          </el-table-column>
          <el-table-column :label="aLang.c_action" align="center" width="200px">
            <template slot-scope="scope">
              <el-button size="mini" @click="fn_handle('detail', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail">
                <i class="fa fa-eye"></i>
              </el-button>
              <el-button size="mini" @click="fn_handle('update', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update" :disabled="fn_checkUpdateInformationRole(scope.row)">
                <i class="icon-pencil icons"></i>
              </el-button>
              <el-button size="mini" @click="fn_handle('changePass', scope.$index, scope.row)"
                v-b-popover.hover.left="'Đổi mật khẩu'" :disabled="fn_checkChangePassRole(scope.row)">
                <i class="icon-key icons"></i>
              </el-button>
              <el-button size="mini" @click="fn_handle('changeRole', scope.$index, scope.row)"
                v-b-popover.hover.left="'Đổi quyền người dùng'" :disabled="fn_checkEditRole(scope.row)">
                <i class="icon-user icons"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div v-if="mData.tableRules.allowSelect">{{ aLang.c_select }}: {{ mData.tableRules.recordSelected.length }}
            </div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination @size-change="fn_tableSizeChange" @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick" @next-click="fn_tableNextClick" :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit" :current-page="mData.tableRules.page" background
              layout="total, sizes, prev, pager, next, jumper" :total="mData.tableRules.total"
              :pager-count="5"></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import AccountApi from '../../../moduleApi/AccountApi';
import ProfileApi from '@/moduleApi/ProfileApi';
import MethodService from '../../../service/MethodService';
import NguoiDungModel from './NguoiDungModel';
import DataService from '../../../service/DataService';
import ApiService from '@/service/ApiService';
import config from "../../../config.json";
import KhachDuLichApi from '@/moduleApi/KhachDuLichApi';
export default {
  data() {
    return {
      aLang: LanguageService.lang,
      mData: {
        moduleName: "NguoiDung", //requied
        tableRules: MethodService.copyObject(NguoiDungModel.tableRules),
        dataDefault: {
          accountRoles: DataService.accountRoles,
          accountRolesSearch: DataService.accountRolesSearch,
          listKhachDuLich: [],
          listHuongDanVien: [],
          listProfile: [],
          listKhachDuLichSearch: [],
          listHuongDanVienSearch: [],
          listProfileSearch: [],
          listTenNguoiDung: [],
          listLockStatus: DataService.lockStatusList,
        }
      }
    }
  },
  created() {
    this.fn_hashUrl();
    // this.getNguoiDungList();
    // this.fn_getTenNguoiDung();
  },
  mounted() {
    this.getNguoiDungList();
  },
  methods: {
    async getNguoiDungList() {
      let dataFilter = {
        filters: (this.mData.tableRules.filters ? this.mData.tableRules.filters + "&" : "") + "roles:nin:SafePlaceManager,Destination,ExportChecklistData"
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-" + this.mData.moduleName + "-list",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters
            }
          }).catch(() => { });
      }

      let res = await AccountApi.list(dataFilter);
      let resData = await this.fn_changeData(res.result);

      //end get name
      this.mData.tableRules.data = resData;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.getNguoiDungList();
      }
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      let arrAccountId = MethodService.findListItemDifferent(resData, "id");
      let reqProfileApi = ProfileApi.list({
        limit: arrAccountId.length,
        filters: "id:in:" + arrAccountId.join(",")
      });
      let reqKhachDuLichApi = KhachDuLichApi.list({
        limit: arrAccountId.length,
        filters: "id:in:" + arrAccountId.join(",")
      });
      let reqHuongDanVienApi = ApiService.get(config.hostApiDuLich + "huong_dan_viens?id:in:" + arrAccountId.join(",") + "&$limit=" + arrAccountId.length, {});
      let resProfileApi = await reqProfileApi;
      let resKhachDuLichApi = await reqKhachDuLichApi;
      let resHuongDanVienApi = await reqHuongDanVienApi;

      this.mData.dataDefault.listProfile = resProfileApi.result;
      this.mData.dataDefault.listKhachDuLich = resKhachDuLichApi.result;
      this.mData.dataDefault.listHuongDanVien = resHuongDanVienApi.result;

      $.each(resData, (index, item) => {
        let nguoiGuiKhachDL = this.mData.dataDefault.listKhachDuLich.find(
          element => {
            return element.id == item.id;
          }
        );
        let nguoiGuiHDV = this.mData.dataDefault.listHuongDanVien.find(
          element => {
            return element.id == item.id;
          }
        );
        let nguoiGui = this.mData.dataDefault.listProfile.find(
          element => {
            return element.id == item.id;
          }
        );
        if (nguoiGuiKhachDL) {
          item.name =
            nguoiGuiKhachDL.ho_ten && nguoiGuiKhachDL.ho_ten.ho_ten
              ? nguoiGuiKhachDL.ho_ten.ho_ten
              : "";
        } else if (nguoiGuiHDV) {
          item.name =
            nguoiGuiHDV.ho_ten && nguoiGuiHDV.ho_ten.ho_ten
              ? nguoiGuiHDV.ho_ten.ho_ten
              : "";
        } else if (nguoiGui) {
          item.name =
            nguoiGui.ho_ten && nguoiGui.ho_ten.ho_ten
              ? nguoiGui.ho_ten.ho_ten
              : "";
        }
      });
      return resData;
    },

    async fn_getTenNguoiDung() {
      this.mData.dataDefault.listTenNguoiDung = [];
      let dataFilter = {
        filters: "roles:nin:SafePlaceManager,Destination,ExportChecklistData"
      };
      dataFilter.limit = 1000000;
      let res = await AccountApi.list(dataFilter);
      let arrAccountId = MethodService.findListItemDifferent(res.result, "id");
      let reqProfileApi = ProfileApi.list({
        limit: arrAccountId.length,
        filters: "id:in:" + arrAccountId.join(",")
      });
      let reqKhachDuLichApi = KhachDuLichApi.list({
        limit: arrAccountId.length,
        filters: "id:in:" + arrAccountId.join(",")
      });
      let reqHuongDanVienApi = ApiService.get(config.hostApiDuLich + "huong_dan_viens?id:in:" + arrAccountId.join(",") + "&$limit=" + arrAccountId.length, {});
      let resProfileApi = await reqProfileApi;
      let resKhachDuLichApi = await reqKhachDuLichApi;
      let resHuongDanVienApi = await reqHuongDanVienApi;

      this.mData.dataDefault.listProfileSearch = resProfileApi.result;
      this.mData.dataDefault.listKhachDuLichSearch = resKhachDuLichApi.result;
      this.mData.dataDefault.listHuongDanVienSearch = resHuongDanVienApi.result;

      (this.mData.dataDefault.listProfileSearch || []).forEach(item => {
        this.mData.dataDefault.listTenNguoiDung.push({ id: item.id, ho_ten: (item.ho_ten && item.ho_ten.ho_ten ? item.ho_ten.ho_ten : '') });
      });

      (this.mData.dataDefault.listKhachDuLichSearch || []).forEach(item => {
        this.mData.dataDefault.listTenNguoiDung.push({ id: item.id, ho_ten: (item.ho_ten && item.ho_ten.ho_ten ? item.ho_ten.ho_ten : '') });
      });

      (this.mData.dataDefault.listHuongDanVienSearch || []).forEach(item => {
        this.mData.dataDefault.listTenNguoiDung.push({ id: item.id, ho_ten: (item.ho_ten && item.ho_ten.ho_ten ? item.ho_ten.ho_ten : '') });
      });
    },

    //event table
    fn_tableSelectionChange(val) {
      let _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },
    async fn_changeDisable(id, trangThai) {
      if (trangThai) {
        await AccountApi.disable(id);
      } else {
        await AccountApi.undisable(id);
      }
      this.getNguoiDungList();
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.getNguoiDungList();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async valid => {
        if (valid && !this.mData.dataDefault.validErrorTime) {
          if (this.mData.tableRules.dataSearch.value.roles == "User" || this.mData.tableRules.dataSearch.value.roles == "UserG") {
            this.mData.tableRules.filters = MethodService.filterTable(
              JSON.stringify(this.mData.tableRules.dataSearch)
            ) + "&account:regex:^\\d+$";
            this.mData.tableRules.offset = 0;
            this.mData.tableRules.sort = "";
            this.getNguoiDungList();
          } else {
            this.mData.tableRules.filters = MethodService.filterTable(
              JSON.stringify(this.mData.tableRules.dataSearch)
            );
            this.mData.tableRules.offset = 0;
            this.mData.tableRules.sort = "";
            this.getNguoiDungList();
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.getNguoiDungList();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },
    fn_formatterRoles(row, column, cellValue) {
      let roles = [];
      let rolesWithoutUser = [];
      cellValue.forEach(item => {
        let res = this.mData.dataDefault.accountRoles.find(function (el) {
          return el.code == item;
        });
        if (res) {
          roles.push(res.text);
        }

        if (roles.length == 2) {
          rolesWithoutUser = roles.filter(x => (x != 'Khách du lịch'));
        } else {
          rolesWithoutUser = roles;
        }
      });
      return rolesWithoutUser.join(" ,");
    },

    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        }).then(() => {
          this.fn_delete(row.id);
        }).catch(() => { });
      }
      if (type == "changePass") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id },
          query: {
            viewMode: "changePass"
          }
        });
      }
      if (type == "changeRole") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id },
          query: {
            viewMode: "changeRole"
          }
        });
      }
    },
    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }

      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    },
    fn_checkEditRole(user) {
      return (user.roles.includes("TourGuide") || user.roles.includes("TourAgent") || user.roles.includes("UserG")) ||
        (user.roles.length == 1 && (user.roles.includes("User") || user.roles.includes("UserG")))
    },
    fn_checkChangePassRole(user) {
      return user.roles.includes("UserG") || (user.roles.length == 1 && user.roles.includes("User"))
    },
    fn_checkUpdateInformationRole(user) {
      return (user.roles.includes("TourGuide") || user.roles.includes("UserG")) ||
        (user.roles.length == 1 && (user.roles.includes("User") || user.roles.includes("UserG")))
    },
  }
}
</script>
